import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import SoldPropertiesListPage from '../components/SoldPropertiesListPage'
import {
  actionCreators,
  ISoldPropertiesListState,
  selectDateRange,
  selectError,
  selectIsLoading,
  selectItems,
  selectListingType,
  selectOrderBy,
  selectSortOrder,
  selectTotalItems,
} from '../modules/soldPropertiesList'

export default connect(
  createStructuredSelector<
    ApplicationState,
    ISoldPropertiesListState & IGlobalConfigurationState
  >({
    configuration: selectConfiguration(),
    dateRange: selectDateRange(),
    error: selectError(),
    isLoading: selectIsLoading(),
    items: selectItems(),
    listingType: selectListingType(),
    orderBy: selectOrderBy(),
    sortOrder: selectSortOrder(),
    totalItems: selectTotalItems(),
  }),
  actionCreators,
)(SoldPropertiesListPage)
